import { takeEvery, put, delay, call, select } from 'redux-saga/effects';
import API_ENDPOINTS from '@services/apiConfig';
import axios from 'axios';
import AuthManager from '@services/AuthManager';
import { dialogActions, masterDataSelectors, uiActions, merchantActions } from '.';

//  Action types
export const actionTypes = {
  verifyPan: 'verifyPan/INITIATE',
  verifyPanSuccess: 'verifyPan/SUCCESS',
  verifyPanFailed: 'verifyPan/FAILED',
  submitPan: 'submitPan/INITIATE',
  submitPanSuccess: 'submitPan/SUCCESS',
  submitPanFailed: 'submitPan/FAILED',
};

const initialState = {
  verify: {
    processing: false,
    valid: false,
    errMsg: null,
    panCardNumber: null,
    panName: null,
  },
  submit: {
    processing: false,
    response: null
  },
};

//  Reducer
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.verifyPan:
      return {
        ...state,
        verify: {
          ...initialState.verify,
          processing: true,
        },
      };
    case actionTypes.verifyPanSuccess:
      return {
        ...state,
        verify: {
          ...initialState.verify,
          processing: false,
          valid: true,
          ...action.payload
        },
      };
    case actionTypes.verifyPanFailed:
      return {
        ...state,
        verify: {
          ...initialState.verify,
          processing: false,
          valid: false,
          errMsg: action.payload
        },
      };
    case actionTypes.submitPan:
      return { ...state, submit: { processing: true, response: null } };
    case actionTypes.submitPanSuccess:
    case actionTypes.submitPanFailed:
      return { ...state, submit: { processing: true, response: action.payload } };
    default: {
      return state;
    }
  }
};

//  Selectors
export const selectors = {
  verifying: state => state.onboardingApp.panDetails.verify.processing,
  verifiedPanDetails: state => {
    const { panCardNumber, panName, gstDetails } = state.onboardingApp.panDetails.verify;
    return { panCardNumber, panName, gstDetails };
  },
  errMsg: state => state.onboardingApp.panDetails.verify.errMsg,
  submitProcessing: state => state.onboardingApp.panDetails.submit.processing,
};


//  Actions
export const actions = {
  verifyPan: panCardNumber => ({ type: actionTypes.verifyPan, payload: panCardNumber }),
  submitPan: buinessEntity => ({ type: actionTypes.submitPan, payload: buinessEntity }),
};

//  Workers
function* verifyPanWorker(action) {
  const { payload: pan_number } = action;
  try {
    const response = yield call(
      [axios, 'post'],
      API_ENDPOINTS.PAN_GSTIN(AuthManager.getMerchantUUID()),
      { pan_number }
    ) || { data: { pan_detail: {} } };
    const { pan_detail: { name: panName }, gst_details } = response.data;
    yield put({
      type: actionTypes.verifyPanSuccess,
      payload: {
        panName,
        panCardNumber: pan_number,
        gstDetails: gst_details,
      }
    });
    yield put(dialogActions.open('pan-confirmation'));
  } catch {
    yield put({
      type: actionTypes.verifyPanFailed,
      payload: 'Pan not valid'
    })
  }
}

function* submitPanWorker(action) {
  const { payload: business_entity } = action;
  const {
    panCardNumber: pancard_number, panName: pancard_name,
  } = yield select(selectors.verifiedPanDetails);
  const buinessEntities = yield select(masterDataSelectors.businessEntities);
  const business_entity_id = buinessEntities.list.find(entity => entity.name === business_entity).id;
  try {
    const { data: response } = yield call(
      [axios, 'put'],
      API_ENDPOINTS.SUBMIT_ONBOARDING_DETAILS(AuthManager.getMerchantUUID()),
      { merchant: { pancard_number: pancard_number.toUpperCase(), business_entity_id } },
    );
    yield put(dialogActions.close());
    yield put(merchantActions.updateMerchantDetails(response.merchant));
    yield put(uiActions.loadUI(response.merchant));
    yield put({ type: actionTypes.submitPanSuccess, payload: response.merchant });
  } catch {
    yield put({ type: actionTypes.submitPanFailed });
    yield put(dialogActions.close());
    yield put({
      type: actionTypes.verifyPanFailed,
      payload: 'Pan not valid'
    })
  }
}

//  Sagas
export function* saga() {
  yield takeEvery(actionTypes.verifyPan, verifyPanWorker);
  yield takeEvery(actionTypes.submitPan, submitPanWorker);
}